import gql from 'graphql-tag';

export type UserPartnerDispossessionMonth = {
  period: string;
  upsCount: number;
  amazonCount: number;
};

export type UserPartnerDispossessionStatistics = {
  accessPointID: string | null;
  amazonAccessPointId: string | null;
  upsThisMonth: number;
  upsLastMonth: number;
  amazonThisMonth: number;
  amazonLastMonth: number;
  months: UserPartnerDispossessionMonth[];
};

export type InternalUserPartnerDispossessionStatisticsQuery = {
  internalUserPartnerDispossessionStatistics: UserPartnerDispossessionStatistics;
};

export const GET_USER_PARTNER_DISPOSSESSION_STATISTICS = gql`
  query InternalUserPartnerDispossessionStatistics($userId: String!, $startPeriod: String, $endPeriod: String) {
    internalUserPartnerDispossessionStatistics(userId: $userId, startPeriod: $startPeriod, endPeriod: $endPeriod) {
      accessPointID
      amazonAccessPointId
      upsThisMonth
      upsLastMonth
      amazonThisMonth
      amazonLastMonth
      months {
        period
        upsCount
        amazonCount
      }
    }
  }
`;
